import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaTicketAlt } from 'react-icons/fa';
import './AddCoupon.scss';

interface AddCouponProps {
    show: boolean;
    onHide: () => void;
    onAddCoupon: (code: string) => Promise<void>;
}

const AddCoupon: React.FC<AddCouponProps> = ({ show, onHide, onAddCoupon }) => {
    const [couponCode, setCouponCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!couponCode.trim()) {
            setError('Por favor ingresa un código de cupón');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            await onAddCoupon(couponCode.trim().toUpperCase());
            setCouponCode('');
            onHide();
        } catch (err: any) {
            setError(err.message || 'Error al agregar el cupón');
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setCouponCode('');
        setError('');
        onHide();
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose}
            centered
            className="add-coupon-modal"
        >
            <div className="add-coupon-content">
                <button className="close-btn" onClick={handleClose}>
                    <FaTimes />
                </button>

                <div className="modal-icon">
                    <FaTicketAlt />
                </div>

                <h2 className="modal-title">Agregar Cupón</h2>
                <p className="modal-subtitle">
                    Ingresa el código de tu cupón para agregarlo a tu cuenta
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <input
                            type="text"
                            className="coupon-input"
                            placeholder="Ej: BIENVENIDA2024"
                            value={couponCode}
                            onChange={(e) => {
                                setCouponCode(e.target.value.toUpperCase());
                                setError('');
                            }}
                            disabled={isLoading}
                            maxLength={20}
                        />
                    </div>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    <button 
                        type="submit" 
                        className="submit-btn"
                        disabled={isLoading || !couponCode.trim()}
                    >
                        {isLoading ? 'Agregando...' : 'Agregar Cupón'}
                    </button>
                </form>
            </div>
        </Modal>
    );
};

export default AddCoupon;
